import roomData from "./roomSlice.jsx";
import { configureStore } from "@reduxjs/toolkit";

export default configureStore({
    reducer: { roomData },
});
